export default "__VITE_ASSET__f90898b4__"